import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { ExportOptions } from "components/ExportOptions/ExportOptions";
import {
  REPORT_EXPORT_TYPES,
  REPORT_EXPORT_TYPES_TYPE,
} from "constants/reportExportTypes";
import { useToast } from "hooks/useToast";
import { useExportIVRCallMutation } from "store/apis/broadcastCall";
import { BackendError } from "types/utils/error";

type BroadcastCallExportProps = {
  broadcastCallId: string;
};

export const BroadcastCallExport = ({
  broadcastCallId,
}: BroadcastCallExportProps) => {
  const [exportIVRReport] = useExportIVRCallMutation();
  const { alertToast, successToast } = useToast();

  const exportReport = async (exportType: REPORT_EXPORT_TYPES_TYPE) => {
    try {
      const res = await exportIVRReport({
        campaign_uuids: broadcastCallId,
        generate_report: exportType === REPORT_EXPORT_TYPES.GENERATE_REPORT,
        export_to_email: exportType === REPORT_EXPORT_TYPES.EXPORT_TO_MAIL,
      }).unwrap();

      if (res?.download_url) {
        window.open(res?.download_url);
      }

      successToast({
        message:
          exportType === REPORT_EXPORT_TYPES.EXPORT_TO_MAIL
            ? "Broadcast call report has been sent to your email"
            : "Broadcast call report downloaded successfully",
      });
    } catch (error) {
      alertToast({ message: (error as BackendError)?.data?.error?.message });
    }
  };

  return (
    <Dropdown.Sub>
      <Dropdown.SubTrigger className="t-group t-outline-none hover:t-outline-none focus-visible:t-outline-none">
        Export
      </Dropdown.SubTrigger>
      <Dropdown.Portal>
        <Dropdown.SubContent sideOffset={10} alignOffset={-5}>
          <ExportOptions
            onLocalDownload={() =>
              exportReport(REPORT_EXPORT_TYPES.GENERATE_REPORT)
            }
            onMailExport={() =>
              exportReport(REPORT_EXPORT_TYPES.EXPORT_TO_MAIL)
            }
          />
        </Dropdown.SubContent>
      </Dropdown.Portal>
    </Dropdown.Sub>
  );
};
